import type {
  WithdrawalFlowConfig,
  WithdrawalSourceTokenOption,
} from '../flow/withdrawalFlowConfig'

/**
 * The source tokens the user may pick between. A host with one source omits
 * `sourceTokens`, leaving the single `sourceToken` as the only option.
 *
 * Stays local to React Native: web's option type is keyed by symbol and carries
 * per-option checkout data, so there is no shared shape to resolve against.
 */
export function resolveWithdrawalSourceTokens(
  config: Pick<WithdrawalFlowConfig, 'sourceToken' | 'sourceTokens'>,
): WithdrawalSourceTokenOption[] {
  const options = config.sourceTokens ?? []
  return options.length > 0 ? options : [{ token: config.sourceToken }]
}
